var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTools(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_624_3065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4434 6.58911L28.0061 9.02733C28.0061 9.02733 26.3803 9.83977 24.7554 8.214C23.1297 6.58911 23.9421 4.96333 23.9421 4.96333L26.3803 2.52511C27.1937 1.71266 26.2168 0.967773 25.4834 0.967773C21.8826 0.967773 18.9643 3.886 18.9643 7.486C18.9643 7.99177 19.0283 8.48244 19.1368 8.95533L13.6266 14.4656L18.5021 19.3411L24.0123 13.8318C24.4861 13.9402 24.9759 14.0042 25.4826 14.0042C29.0826 14.0042 32.0008 11.086 32.0008 7.486C32.0017 6.74822 31.2559 5.77666 30.4434 6.58911ZM13.5306 14.6247L2.69589 25.4584C1.367 26.7882 1.367 28.9438 2.69589 30.2736C4.02655 31.6024 6.18122 31.6024 7.511 30.2736L18.3439 19.4398L13.5306 14.6247ZM5.12433 29.2682C4.39633 29.2682 3.807 28.678 3.807 27.9509C3.807 27.2238 4.39722 26.6327 5.12433 26.6327C5.85233 26.6327 6.44166 27.2229 6.44166 27.9509C6.44166 28.678 5.85233 29.2682 5.12433 29.2682Z",
    fill: "#8899A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4043 30.5491C28.4408 31.5855 30.0905 31.6344 31.0674 30.6566C32.0452 29.6788 31.9963 28.0299 30.9599 26.9935L10.2799 6.3135C9.24253 5.27617 7.59453 5.22817 6.61676 6.20594C5.63898 7.18372 5.68787 8.83261 6.72431 9.86906L27.4043 30.5491Z",
    fill: "#F4900C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0617 1.76165C19.0617 1.76165 13.7284 -0.905016 9.28395 3.53943L3.06173 9.76165C3.06173 9.76165 2.17284 8.87276 1.28395 9.76165L0.395062 10.6505C0.395062 10.6505 -0.493827 11.5394 0.395062 12.4283L3.95062 15.9839C3.95062 15.9839 4.83951 16.8728 5.72839 15.9839L6.61728 15.095C6.61728 15.095 7.50617 14.2061 6.61728 13.3172L6.54795 13.2479C7.2324 12.5874 8.25728 11.9145 9.28395 12.4283L12.8395 8.87276C12.8395 8.87276 11.9506 6.20609 13.7284 4.42832C15.5062 2.65054 16.3951 2.65054 18.1728 2.65054C19.9506 2.65054 19.0617 1.76165 19.0617 1.76165Z",
    fill: "#66757F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_624_3065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.967773)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/tools.08ebdbff979091ee7218cb74e80afe08.svg";
export { ForwardRef as ReactComponent };